import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';
import Transition from '../utils/Transition';

import { getApiBaseUrl, getFrontEndBaseUrl } from 'runtimeApi'


import { useCurrentUser } from 'currentUserContext'

import CompleteProfile from 'components/Users/CompleteProfile'
import Modal from 'components/Modal'

import axios from 'axios'

function DropdownProfile({
  align
}) {

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const [show_complete_profile, setShowCompleteProfile] = useState(false)

  const trigger = useRef(null);
  const dropdown = useRef(null);

  const current_user = useCurrentUser()

  const avatar_label = (current_user?.initials || current_user?.email?.[0] || '?').toUpperCase()

  const logout = () => {
    axios({
        method: 'DELETE',
        url: `${getApiBaseUrl()}/sign_out`,
        maxRedirects: 0,
      })
        .then(() => {})
        .catch((err) => {
          if (err.response.status === 404) {
            // client.resetStore()
            window.location = getFrontEndBaseUrl()
          }
        })
  }

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!dropdown.current) return;
      if (!dropdownOpen || dropdown.current.contains(target) || trigger.current.contains(target)) return;
      setDropdownOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  return (
    <div className="relative inline-flex">
      <button
        ref={trigger}
        className="inline-flex justify-center items-center group"
        aria-haspopup="true"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        aria-expanded={dropdownOpen}
      >
        <div className="w-8 h-8 rounded-full bg-slate-200 dark:bg-slate-700 text-slate-700 dark:text-slate-200 flex items-center justify-center text-xs font-semibold">
          {avatar_label}
        </div>
        <div className="flex items-center truncate">
          <span className="truncate ml-2 text-sm font-medium group-hover:text-slate-800 dark:hover:text-slate-100">{current_user.email}</span>
          <svg className="w-3 h-3 shrink-0 ml-1 fill-current text-slate-400 dark:text-slate-500" viewBox="0 0 12 12">
            <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
          </svg>
        </div>
      </button>

      <Transition
        className={`origin-top-right z-10 absolute top-full min-w-44 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 py-1.5 rounded shadow-lg overflow-hidden mt-1 ${align === 'right' ? 'right-0' : 'left-0'}`}
        show={dropdownOpen}
        enter="transition ease-out duration-200 transform"
        enterStart="opacity-0 -translate-y-2"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-out duration-200"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
      >
        <div
          ref={dropdown}
          onFocus={() => setDropdownOpen(true)}
          onBlur={() => setDropdownOpen(false)}
        >
          <div className="pt-0.5 pb-2 px-3 mb-1 border-b border-slate-200 dark:border-slate-700">
            <div className="font-medium text-slate-800 dark:text-slate-100">{current_user.email}</div>
            <div className="text-xs text-slate-500 dark:text-slate-400">{[current_user.role, current_user.department].filter((x) => x).join(' | ')}</div>
          </div>
          <ul>
            <li>
              <button
                className="font-medium text-sm text-indigo-500 hover:text-indigo-600 flex items-center py-1 px-3"
                type="button"
                onClick={() => setShowCompleteProfile(true)}
              >
                Complete Profile
              </button>
            </li>
            <li>
              <Link
                className="font-medium text-sm text-indigo-500 hover:text-indigo-600 flex items-center py-1 px-3"
                to={`/users/${current_user.id}/account`}
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                Settings
              </Link>
            </li>
            <li>
              <button
                className="font-medium text-sm text-indigo-500 hover:text-indigo-600 flex items-center py-1 px-3"
                to="/signin"
                onClick={logout}
              >
                Sign Out
              </button>
            </li>
          </ul>
        </div>
      </Transition>
			<Modal
				show={show_complete_profile}
				modalWillClose={() => false}
				modalDidClose={() => setShowCompleteProfile(false)}
				style={{background: 'transparent'}}
			>
				<CompleteProfile
					onClose={() => setShowCompleteProfile(false)}
				/>
			</Modal>
    </div>
  )
}

DropdownProfile.propTypes = {
  align: PropTypes.string,
}

export default DropdownProfile;
